import axios from "axios";

const baseUrl = process.env.REACT_APP_StrapiUrl;

// https://d29l6pux0tl1f7.cloudfront.net/api/transcategories

const getTourScreens = async () => {
  try {
    const response = await axios.get(baseUrl + "tutorials");
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};

const getHome = async () => {
  try {
    const response = await axios.get(baseUrl + "homes");
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};

const getOffers = async () => {
  try {
    const response = await axios.get(baseUrl + "offers");
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};

const getTiers = async () => {
  try {
    const response = await axios.get(baseUrl + "abconfigs");
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};

const getBrands = async (pageNum = 1) => {
  try {
    const response = await axios.get(
      baseUrl +
        `Brandslists?pagination%5Bpage%5D=${pageNum}&pagination%5BpageSize%5D=100`
    );
    if (response.status === 200) {
      const dataObj = response.data;

      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};

const getBrandByIdAndName = async (id) => {
  try {
    const response = await axios.get(
      `${baseUrl}brandslists?filters[brand_id][$eq]=${id}`
    );
    if (response.status === 200) {
      const dataObj = response.data;

      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};
const getBrandsCategory = async () => {
  try {
    const response = await axios.get(baseUrl + "brandcategories");
    if (response.status === 200) {
      const dataObj = response.data.data[0].attributes.data;

      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};
const getRewardCatalogCategory = async () => {
  try {
    const response = await axios.get(baseUrl + "marvalcategories");
    if (response.status === 200) {
      const dataObj = response.data.data[0].attributes.data;

      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};
const getTransactionCategory = async () => {
  try {
    const response = await axios.get(baseUrl + "transcategories");
    if (response.status === 200) {
      const dataObj = response.data.data[0].attributes.data;

      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};
const getReceiptCategory = async () => {
  try {
    const response = await axios.get(baseUrl + "receiptcategories");
    if (response.status === 200) {
      const dataObj = response.data.data[0].attributes.data;

      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};
const getStoresCategory = async () => {
  try {
    const response = await axios.get(baseUrl + "storecategories");
    if (response.status === 200) {
      const dataObj = response.data.data[0].attributes.data;

      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};

const getTermsAndConditions = async () => {
  try {
    const response = await axios.get(baseUrl + "termsandconditions");
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};

const getStoreImages = async () => {
  try {
    const response = await axios.get(baseUrl + "storeimagelists");
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};
const getCountryCodeList = async () => {
  try {
    const res = await axios.get(baseUrl + "countrylists");
    if (res.status === 200) {
      const dataObj = res.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};
const getFaqs = async () => {
  try {
    const response = await axios.get(baseUrl + "faqs");
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  } catch (e) {
    console.log(e);
  }
};
// https://d29l6pux0tl1f7.cloudfront.net/api/e-bill-templates?filters[brandName][$eq]=Victoria%27s%20Secret&populate=*
const getTransBillStyle=async(brandName)=>{
  try{
    const response=await axios.get(baseUrl+`e-bill-templates?filters[brandName][$eq]=${brandName}&populate=*`);
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  }catch(e){
    console.log(e);
  }
}

const getGamesTerms = async(gameId)=>{
  try{
    const response=await axios.get(baseUrl+`games?filters[game_id][$eq]=${gameId}`);
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  }catch(e){
    console.log(e);
  }
}

const getMultiBrands = async(storeId)=>{
  try{
    const response=await axios.get(baseUrl+`subs?filters%5Bstorecode%5D%5B$eq%5D=${storeId}`);
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  }catch(e){
    console.log(e);
  }
}

const getBrandsRecipt = async()=>{
  try{
    const response=await axios.get(baseUrl+`brandslistreceipts`);
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  }catch(e){
    console.log(e);
  }
}

const getBrandsAddress = async(storeCode)=>{
  try{
    const response=await axios.get(baseUrl+`transaction-store-addresses?filters[store_code][$eq]=${storeCode}`);
    if (response.status === 200) {
      const dataObj = response.data;
      return dataObj;
    } else {
      console.log("request failed");
      return [];
    }
  }catch(e){
    console.log(e);
  }
}

export {
  getTourScreens,
  getHome,
  getOffers,
  getTiers,
  getBrands,
  getBrandByIdAndName,
  getBrandsCategory,
  getTermsAndConditions,
  getStoreImages,
  getCountryCodeList,
  getTransactionCategory,
  getReceiptCategory,
  getStoresCategory,
  getFaqs,
  getRewardCatalogCategory,
  getTransBillStyle,
  getGamesTerms,
  getMultiBrands,
  getBrandsRecipt,
  getBrandsAddress
};
